module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/zh-hans_3-80f9476082df026b0fa941b7d61a1f8f.jpg";